import { formatNative, formatUsd, getCurrencyLabel } from './optionsDashboardUtils';

export const OPTIONS_CURRENCY_VISUALS = {
  all: { label: 'All', assetKey: null },
  usd: { label: 'USD', assetKey: 'usd' },
  usdc: { label: 'USDC', assetKey: 'usdc' },
  usdt: { label: 'USDT', assetKey: 'usdt' },
  btc: { label: 'BTC', assetKey: 'btc' },
  eth: { label: 'ETH', assetKey: 'eth' },
};

export const OPTIONS_STRATEGY_VISUALS = {
  LONG_CALL: {
    badgeClassName: 'border-[#22C55E]/25 bg-[#22C55E]/12 text-[#BDFACD]',
    accentCardClassName: 'border-[#22C55E]/18 bg-[linear-gradient(180deg,rgba(34,197,94,0.10),rgba(255,255,255,0.02))]',
  },
  LONG_PUT: {
    badgeClassName: 'border-[#EF4444]/25 bg-[#EF4444]/12 text-[#FFC5C5]',
    accentCardClassName: 'border-[#EF4444]/18 bg-[linear-gradient(180deg,rgba(239,68,68,0.10),rgba(255,255,255,0.02))]',
  },
  SHORT_PUT: {
    badgeClassName: 'border-[#16A34A]/25 bg-[#16A34A]/12 text-[#BDFACD]',
    accentCardClassName: 'border-[#16A34A]/18 bg-[linear-gradient(180deg,rgba(22,163,74,0.10),rgba(255,255,255,0.02))]',
  },
  SHORT_CALL: {
    badgeClassName: 'border-[#F97316]/25 bg-[#F97316]/12 text-[#FFD0AF]',
    accentCardClassName: 'border-[#F97316]/18 bg-[linear-gradient(180deg,rgba(249,115,22,0.10),rgba(255,255,255,0.02))]',
  },
  SHORT_STRANGLE: {
    badgeClassName: 'border-[#F59E0B]/25 bg-[#F59E0B]/12 text-[#FFD788]',
    accentCardClassName: 'border-[#F59E0B]/18 bg-[linear-gradient(180deg,rgba(245,158,11,0.10),rgba(255,255,255,0.02))]',
  },
  SHORT_STRADDLE: {
    badgeClassName: 'border-[#FACC15]/25 bg-[#FACC15]/12 text-[#FFF1A8]',
    accentCardClassName: 'border-[#FACC15]/18 bg-[linear-gradient(180deg,rgba(250,204,21,0.10),rgba(255,255,255,0.02))]',
  },
  CALL_SPREAD: {
    badgeClassName: 'border-[#38BDF8]/25 bg-[#38BDF8]/12 text-[#C9F1FF]',
    accentCardClassName: 'border-[#38BDF8]/18 bg-[linear-gradient(180deg,rgba(56,189,248,0.10),rgba(255,255,255,0.02))]',
  },
  PUT_SPREAD: {
    badgeClassName: 'border-[#FB7185]/25 bg-[#FB7185]/12 text-[#FFD0D9]',
    accentCardClassName: 'border-[#FB7185]/18 bg-[linear-gradient(180deg,rgba(251,113,133,0.10),rgba(255,255,255,0.02))]',
  },
  IRON_CONDOR: {
    badgeClassName: 'border-[#A855F7]/25 bg-[#A855F7]/12 text-[#E7C8FF]',
    accentCardClassName: 'border-[#A855F7]/18 bg-[linear-gradient(180deg,rgba(168,85,247,0.10),rgba(255,255,255,0.02))]',
  },
  DEFAULT: {
    badgeClassName: 'border-white/10 bg-white/[0.05] text-white/80',
    accentCardClassName: 'border-white/10 bg-black/20',
  },
};

export const getCurrencyVisual = (currencyKey) => {
  return OPTIONS_CURRENCY_VISUALS[currencyKey] || { label: getCurrencyLabel(currencyKey), assetKey: currencyKey };
};

export const getStrategyVisual = (strategyKey) => {
  return OPTIONS_STRATEGY_VISUALS[strategyKey] || OPTIONS_STRATEGY_VISUALS.DEFAULT;
};

export const getPnlToneClass = (value) => {
  if (value === null || value === undefined) return 'text-white';
  if (Number(value) > 0) return 'text-[#22C55E]';
  if (Number(value) < 0) return 'text-[#EF4444]';
  return 'text-white';
};

export const getPnlSecondaryToneClass = (value) => {
  if (value === null || value === undefined) return 'text-white/55';
  if (Number(value) > 0) return 'text-[#8FE5AE]';
  if (Number(value) < 0) return 'text-[#F5A4A4]';
  return 'text-white/55';
};

export const buildMoneyValuePresentation = ({ selectedCurrency, nativeValue, usdValue, underlying, digits = 4, tone = 'neutral' }) => {
  const isUsdView = selectedCurrency === 'usd';
  const numericForTone = isUsdView ? usdValue : nativeValue;

  return {
    primary: isUsdView ? formatUsd(usdValue) : formatNative(nativeValue, underlying, digits),
    secondary: isUsdView
      ? (nativeValue !== null && nativeValue !== undefined ? `≈ ${formatNative(nativeValue, underlying, digits)}` : null)
      : (usdValue !== null && usdValue !== undefined ? `≈ ${formatUsd(usdValue)}` : null),
    primaryToneClass: tone === 'pnl' ? getPnlToneClass(numericForTone) : 'text-white',
    secondaryToneClass: tone === 'pnl' ? getPnlSecondaryToneClass(numericForTone) : 'text-white/55',
    numericForTone,
  };
};